import axios from "axios";

const getBaseUrl = () => {
  const hostname = window.location.hostname;
  console.log("🔍 [Client] Initializing API Client");
  console.log("🔍 [Client] Detected hostname:", hostname);
  console.log("🔍 [Client] Environment:", process.env.NODE_ENV);
  console.log("🔍 [Client] Env API URL:", process.env.REACT_APP_API_URL);

  if (hostname.includes("vortix.digital")) {
    console.log("✅ [Client] Using Production URL: https://vortix.digital/api");
    return "https://vortix.digital/api";
  }

  const url = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
  console.log("⚠️ [Client] Using Fallback URL:", url);
  return url;
};

const API_BASE_URL = getBaseUrl();

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Variable para evitar múltiples llamadas de refresh simultáneas
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Interceptor para agregar token a las requests
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de token
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // Si ya se está refrescando, encolar la request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return client(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        // No hay refresh token, forzar logout
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/auth/token/refresh/`,
          {
            refresh: refreshToken,
          }
        );

        const newToken = response.data.access;
        localStorage.setItem("authToken", newToken);

        // Actualizar el header de la request original
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Procesar cola de requests pendientes
        processQueue(null, newToken);

        // Reintentar la request original
        return client(originalRequest);
      } catch (refreshError) {
        // Error en el refresh, forzar logout
        processQueue(refreshError, null);
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default client;
